import React from 'react';
import { DetailsPhone } from '../components/Home/detailsPhone';
import { Nav } from '../components/Nav/nav';
import { Footer } from '../components/Footer/footer';

export const DetailsPage = () => {
  return (
    <>
      <Nav />
      <DetailsPhone />
      <Footer />
    </>
  );
};
